import React, { FC } from 'react';

import { Stack, Text } from '@chakra-ui/react';

import { DetailsIdentifier } from 'components/DataDisplay';
import { KnowledgeBaseDrawer } from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseDrawer';
import {
  KnowledgeBaseLink,
  KnowledgeBaseLinks,
} from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseLinks';
import { LearnMoreInlineLink } from 'components/DataDisplay/KnowledgeBase/BaseComponents/LearnMoreInlineLink';
import { renderKnowledgeBaseList } from 'components/DataDisplay/KnowledgeBase/utils';

export const LearnMoreAboutFindings: FC = () => {
  const links: KnowledgeBaseLink[] = [
    { label: 'Issues', field: 'issues' },
    { label: 'Ticketing', field: 'ticketing' },
    { label: 'Remediation', field: 'remediation' },
  ];

  return (
    <KnowledgeBaseDrawer
      knowledgeBaseKey="findings"
      headerTitle="Findings"
      body={
        <Stack spacing={10}>
          <Stack spacing={4}>
            <Text fontWeight={600}>Description</Text>
            <Text>
              Findings are detections that are automatically generated by Ariksa
              based on policies applied to one or more cloud accounts. We
              generate findings by automatically correlating across the maximum
              number of risk factors that are both static like toxic
              combinations of configurations and runtime information such as
              user activity, network traffic, software vulnerabilities and other
              activity. Our zero-lift approach means that you can detect risks,
              exposures and vulnerabilities without any manual efforts for data
              collection, analysis, or engineering.
            </Text>
            <Text pt={2}>
              Findings are used to group multiple{' '}
              <LearnMoreInlineLink label="issues" field="issues" value /> that
              are similar in their details, Each resource associated with an
              individual issue under a finding is automatically assessed for its
              unique risk factors and labeled to cumulatively provide its risk
              context – providing a 360º view of risks.
            </Text>
          </Stack>
          <Stack>
            <Text fontWeight={600}>Example of Findings and Issues</Text>
            <Stack spacing={1}>
              <DetailsIdentifier
                label="Finding"
                value="A virtual machine allows ingress network access on port 23 (telnet)"
              />
              <DetailsIdentifier
                label="Issues"
                isInline={false}
                spacing={1}
                value={renderKnowledgeBaseList([
                  'Virtual machine 1 is Internet accessible and has a role with access to sensitive data',
                  'Virtual machine 2 has critical or high vulnerabilities and is Internet exposed',
                  'Virtual machine 3 is not Internet exposed, has role with access to sensitive data',
                ])}
              />
            </Stack>
          </Stack>
          <KnowledgeBaseLinks links={links} />
        </Stack>
      }
    />
  );
};
